import { ICampaign, IApiCampaign } from './types';
import { isAfter, isBefore } from 'date-fns';

export const generateCampaignStatus = (campaign: IApiCampaign): ICampaign => {
  const { startDate, endDate, disabled } = campaign;

  let status: ICampaign['status'] = 'ACTIVE';

  if (disabled) status = 'DISABLED';
  else if (isAfter(new Date(), new Date(endDate))) status = 'EXPIRED';
  else if (isBefore(new Date(), new Date(startDate))) status = 'INACTIVE';

  return {
    ...campaign,
    status,
  };
};
